import { Loader } from 'common';
import { Layout } from 'components/layout';
import { IQuestion, IVariables } from 'constants/types';

import { Breadcrumbs } from 'components/bredcrambs';
import { aboutUs } from 'constants/routes-breadcrumbs';

import { CustomMetadata } from 'components/metadata';
import { allMetadata } from 'constants/metadata';

import { Profiles } from 'components/profile-card';
import { Anchor } from 'constants/anchors';
import { INavItem } from 'constants/types';
import { teamData } from './teamData';
import { ProfileTitle } from './profile-title';
import styles from './styles.module.css';
import { OurTeamCards } from './team';
import { Card } from './card';
import { Icon } from 'common/icon';
import { Title } from './title';
import { NavigationBar } from '../casino/casino-navigations';

const navItems: INavItem[] = [
  {
    text: 'Support',
    anchor: `#${Anchor.Support}`,
    icon: <Icon.MessageFifth />,
  },

  {
    text: 'Our team',
    anchor: `#${Anchor.OurTeam}`,
    icon: <Icon.Question width={16} height={16} />,
  },
];

export const AboutUsPage = ({
  data,
  questions,
}: {
  data: IVariables;
  questions: IQuestion[];
}) => {
  if (!data) {
    return <Loader size="big" />;
  }

  return (
    <div>
      <CustomMetadata metadata={allMetadata.aboutUs} />
      <Layout hasFooter isSearchInputMobileVisible bgVariant="basic">
        <main className={styles.main}>
          <div className={styles.container_s}>
            <Breadcrumbs items={[...aboutUs]} />
            <Title text={'About Us - Contacts - RTPCheck.com Team'} />
            <Card />
            <div className={styles.navigationBar}>
              <NavigationBar
                arrow
                items={navItems}
                navItemClassName={styles.navItem}
                variantBg="notransparent"
                variantPadding="medium"
              />
            </div>
            <ProfileTitle text={'Support'} anchor={Anchor.Support} />
            <Profiles questions={questions} data={teamData.slice(0, 1)} />
            <ProfileTitle text={'Our Team'} anchor={Anchor.OurTeam} />
            <OurTeamCards />
          </div>
        </main>
      </Layout>
    </div>
  );
};
